import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "historial-turnos animate tw-h-full lg:tw-pt-0 tw-w-full tw-flex tw-flex-col tw-p-2 lg:tw-flex-row tw-justify-center tw-items-center" }
const _hoisted_2 = { class: "tw-w-full tw-h-full" }
const _hoisted_3 = { class: "tw-w-full tw-flex tw-justify-between tw-items-center tw-rounded tw-bg-gray-50 tw-p-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Próximas Citas", -1)
const _hoisted_5 = {
  style: {"max-height":"calc(100vh - 15em)"},
  class: "tw-bg-gray-50 tw-overflow-auto tw-rounded tw-p-2"
}
const _hoisted_6 = {
  key: 0,
  class: "tw-p-2 tw-space-y-2"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-w-full tw-bg-gray-50"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, " No posee citas disponibles.", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "tw-text-xl" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Historial de Citas")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" No se encontraron datos. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_proximos_turnos = _resolveComponent("proximos-turnos")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Card, {
        style: {"background":"none","box-shadow":"none"},
        class: "animate tw-h-full tw-w-full"
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.isHistoricoActive)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Historial",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleHistorialClick(true)))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.datosTurnos && _ctx.datosTurnos.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosTurnos, (turno) => {
                    return (_openBlock(), _createBlock(_component_proximos_turnos, {
                      onTurnoEliminado: _ctx.handleTurnoEliminado,
                      key: turno,
                      turno: turno
                    }, null, 8, ["onTurnoEliminado", "turno"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Sidebar, {
      visible: _ctx.slideVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slideVisible) = $event)),
      position: "right",
      class: "tw-w-full! md:tw-w-2/3! xl:tw-w-1/2! tw-text-center!"
    }, {
      default: _withCtx(() => [
        _hoisted_10,
        _createVNode(_component_DataTable, {
          class: "table-historial-turnos",
          style: {},
          value: _ctx.datosHistorico,
          responsiveLayout: "stack",
          scrollHeight: "80vh"
        }, {
          empty: _withCtx(() => [
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "fecha",
              class: "tw-w-24",
              header: "Fecha"
            }),
            _createVNode(_component_Column, {
              field: "hora",
              class: "tw-w-12",
              header: "Hora"
            }),
            _createVNode(_component_Column, {
              field: "especialidad",
              header: "Especialidad"
            }),
            _createVNode(_component_Column, {
              field: "profesional",
              header: "Profesional"
            }),
            _createVNode(_component_Column, {
              field: "vino",
              class: "tw-w-12",
              header: "Presente"
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}